import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-product-anchor',
  templateUrl: './product-anchor.component.html',
  styleUrls: ['./product-anchor.component.scss'],
})
export class ProductAnchorComponent {
  @Input() list = [{ name: '' }];

  activeId: string | null = null;

  onAnchorChange(id: string) {
    this.activeId = id;
  }
}
